import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ProButton } from '@components/Button/variants';
import { PaywallProps } from '@components/Paywall';
import PaywallFull from '@components/Paywall/Standard/Full';

export interface ProjectsPaywallProps extends PaywallProps {
  isLoggedIn: boolean;
}

const ProjectsPaywall = (props: ProjectsPaywallProps): JSX.Element => {
  const { isLoggedIn, ...paywallProps } = props;
  const { buttonText, offerLink, title } = paywallProps;
  return (
    <QueryClientProvider client={new QueryClient()}>
      <div className="bg-white sm:bg-grayscale-charcoal">
        {!isLoggedIn ? (
          <PaywallFull {...paywallProps} />
        ) : (
          <div
            data-testid="paywall"
            className="flex w-full flex-col flex-nowrap items-center justify-center gap-24 px-24 py-32 sm:p-72"
          >
            <h1 className="my-0 max-w-[930px] text-center font-suisse-works text-headline-xs text-black sm:text-headline-lg sm:text-white">
              {title}
            </h1>
            <ProButton as="link" href={offerLink}>
              {buttonText}
            </ProButton>
          </div>
        )}
      </div>
    </QueryClientProvider>
  );
};

export default ProjectsPaywall;
